var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 12.9091C10.9697 14.8485 10 17.2121 10 20C10 17.2121 9.0303 14.8485 7.09091 12.9091C5.15152 10.9697 2.78788 10 0 10C2.78788 10 5.15152 9.0303 7.09091 7.09091C9.0303 5.15152 10 2.78788 10 0C10 2.78788 10.9697 5.15152 12.9091 7.09091C14.8485 9.0303 17.2121 10 20 10C17.2121 10 14.8485 10.9697 12.9091 12.9091Z",
    fill: "url(#paint0_linear_774_7852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_774_7852",
    x1: 18.7184,
    y1: 9.98316,
    x2: 6.55145,
    y2: 9.98316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiLogo);
export default __webpack_public_path__ + "static/media/gemini_logo.970cf8a6cd0f1c272fbbdac53013aab2.svg";
export { ForwardRef as ReactComponent };